export default __webpack_public_path__ + "static/media/Mohini.5954a878.jpeg";